import { EnergyTypeDto, RegisterType } from '@eneco/dc-be/client';
import { Fields } from '@sitecore/types/EnterMeterReadings';
import * as yup from 'yup';

export const getFormSchema = (fields: Fields) => {
  const today = new Date();
  const oneMonthAgo = new Date(today);
  oneMonthAgo.setMonth(today.getMonth() - 1);

  return yup.object({
    meterReadingDate: yup
      .date()
      .typeError(fields.data?.dateFormField.value.validationMessage ?? 'Ongeldige datum opgegeven [not in sitecore]')
      .required(fields.data?.dateFormField.value.requiredMessage ?? 'Datum is verplicht [not in sitecore]')
      .min(
        oneMonthAgo,
        fields.data?.dateFormField.value.validationMinValueMessage ??
          'Datum mag niet meer dan een maand in het verleden liggen [not in sitecore]',
      )
      .max(
        today,
        fields.data?.dateFormField.value.validationMaxValueMessage ??
          'Datum mag niet in de toekomst liggen [not in sitecore]',
      ),
    meterReadings: yup.array().of(
      yup.object({
        accountNumber: yup.string().required(),
        readingValue: yup
          .number()
          .typeError(fields.data?.invalidFormatText?.value ?? 'Voer een geldig getal in [not in sitecore]')
          .integer()
          .required(),
        ean: yup.string().required(),
        meterTimeFrameType: yup.mixed<RegisterType>().required(),
        utilityType: yup.mixed<EnergyTypeDto>().required(),
        direction: yup.string().required(),
      }),
    ),
  });
};

export type AddMeterReadingFormSchema = yup.InferType<ReturnType<typeof getFormSchema>>;
